export default Object.freeze({
  // STOCK_MANAGEMENT_
  TITLE: '상품재고관리',
  DESCRIPTION_DEV1: '승인완료 된 상품만 조회됩니다.',
  DESCRIPTION_DEV2:
    '재고연동 복사 상품인 경우 마스터 상품의 옵션리스트만 조회됩니다.',
  DESCRIPTION_DEV2_1:
    '(재고연동 복사된 상품은 마스터 상품 변경 시 연동되어 동일하게 변경)',
  SEARCH_WORD: '검색어',
  MALLPRODUCTNO: '상품번호',
  PRODUCTNAME: '상품명',
  PRODUCTMANAGEMENTCD: '상품관리코드',
  PRODUCTMANAGEMENTCDLIKE: '상품관리코드|부분검색',
  STOCKNO: '재고번호',
  OPTIONMANAGEMENTCD: '옵션관리코드',
  EXTRAMANAGEMENTCD: '추가관리코드',
  MALLOPTIONNO: '옵션번호',
  KEY_WORD_PLACEHOLDERBEFOR:
    '복수 상품 검색이 가능합니다. (Enter 또는 \',\'로 구분)',
  INPUT_NUMBER_ERROR: '숫자만 입력 가능합니다.',
  KEY_WORD_NUMBER_ERROR: '숫자와 콤마만 입력할 수 있습니다',
  KEY_WORD_NULL_ERROR: '검색어를 입력해주세요.',
  PRODUCT_MANAGEMENTCD_LIKEKEYWORD_PLACEHOLDER:
    '일부 상품관리코드와 %를 이용한 부분 검색이 가능합니다.',
  SALE_STATUS: '판매상태',
  SALE_STATUS_WAITING_PRE_SALE: '예약판매대기',
  SALE_STATUS_ON_PRE_SALE: '예약판매중',
  SALE_STATUS_WAITING_SALE: '판매대기',
  SALE_STATUS_ON_SALE: '판매중',
  SALE_STATUS_END_SALE: '판매종료',
  SALE_SETTING_STATUS: '판매설정',
  SALE_SETTING_STATUS_AVAILABLE_FOR_SALE: '판매가능',
  SALE_SETTING_STATUS_STOP_SELLING: '판매중지',
  SALE_SETTING_STATUS_PROHIBITION_SALE: '판매금지',
  BRAND: '브랜드',
  BRAND_NAME: '브랜드명',
  ENTER_BRAND_NAME: '브랜드명 입력',
  PARTNERS: '파트너사',
  PARTNERS_PLACEHOLDER: '파트너사명 입력',
  TERM_REGISTER_YMDT: '상품등록일',
  TERM_START_YMDT: '판매시작일',
  TERM_END_YMDT: '판매종료일',
  TERM_UPDATE_YMDT: '최종수정일',
  SELECT_PERIOD: '기간선택',
  ADVANCED_SEARCH: '상세검색',
  NO_BRAND_DATA: '등록된 브랜드가 없습니다.',
  STOCKRANGETYPE_NONE: '재고여부',
  SOLD_OUT: '재고없음',
  UNDER_FIVE: '5개 이하',
  UNDER_TEN: '10개 이하',
  UNDER_FIFTY: '50개 이하',
  UNDER_HUNDRED: '100개 이하',
  NONE: '플랫폼구분',
  PC: 'PC',
  MOBILE_APP: '모바일 앱',
  MOBILE_WEB: '모바일 웹',
  LP_TITLE: '\'상품관리코드|부분검색\' 안내',
  NOTICE_P:
    '\'상품관리코드|부분검색\'은 일부 상품관리코드와 %를 이용한 부분검색이 가능합니다.',
  SEARCH_WORD_B: '[검색어]',
  SEARCH_WORD_INPUT: '입력: 검색어가 포함된 상품관리코드를 검색합니다.',
  SEARCH_WORD_PERCENT_SIGN: '[검색어%]',
  SEARCH_WORD_PERCENT_SIGN_INPUT:
    '입력: 검색어가 앞에 포함된 상품관리코드를 검색합니다.',
  PERCENT_SIGN_SEARCH_WORD: '[%검색어]',
  PERCENT_SIGN_SEARCH_WORD_INPUT:
    '입력: 검색어가 뒤에 포함된 상품관리코드를 검색합니다.',
  PRODUCT_INQUIRY_RESULT: '상품조회결과',
  PRODUCT_OPTION: '상품옵션',
  ADJUST_BTN: '조정재고 일괄적용',
  EDIT_BTN: '수정재고 일괄적용',
  FINAL_STORAGE: '최종저장',
  EXCELDOWNLOAD_BTN: '엑셀다운로드',
  EXCELUPLOAD_BTN: '엑셀일괄등록',
  HISTORY_TIT: '상품 재고 변경 이력',
  SHOPPING_MALL_FULL: '쇼핑몰 전체',
  DISPLAY_CATEGORY: '전시 카테고리',
  TYPE_CATEGORY: '표준 카테고리',
  GRIDHEADER_MALLNAME: '쇼핑몰',
  GRIDHEADER_MALLPRODUCTNO: '상품번호',
  GRIDHEADER_PRODUCTMANAGEMENTCD: '상품관리코드',
  GRIDHEADER_PRODUCTNAME: '상품명',
  GRIDHEADER_MALLOPTIONNO: '옵션번호',
  GRIDHEADER_OPTIONMANAGEMENTCD: '옵션관리코드',
  GRIDHEADER_OPTIONNAMEANDVALUE: '옵션명:옵션값',
  GRIDHEADER_BRANDNAME: '브랜드',
  GRIDHEADER_PARTNERNAME: '파트너사',
  GRIDHEADER_SALEPERIOD: '판매기간',
  GRIDHEADER_CATEGORYFULLNAME: '전시카테고리',
  GRIDHEADER_SALEPRICE: '판매가',
  GRIDHEADER_APPLYDISCOUNTSALEPRICE: '할인적용가',
  GRIDHEADER_APPLYOPTIONADDPRICE: '옵션적용가',
  GRIDHEADER_STOCKCNT: '재고수량<br>(판매가능재고)',
  GRIDHEADER_ADJUSTSTOCKCNT: '조정재고',
  GRIDHEADER_EDITSTOCKCNT: '수정재고',
  GRIDHEADER_SAFETYSTOCKCNT: '안전재고',
  GRIDHEADER_SAFETYSTOCKSYNCYN: '안전재고연동여부',
  GRIDHEADER_STOCKNO: '재고번호',
  GRIDHEADER_DELIVERYWAITINGSTOCKCNT: '출고대기',
  GRIDHEADER_STOCKCHANGEHISTORYNO: '상품재고 변경 이력',
  GRIDHEADER_OPTIONSALESTATUSTYPE: '판매상태',
  GRID_SOLD_OUT: '품절',
  GRID_AVAILABLE_FOR_SALE: '판매가능',
  GRID_UPDATEADMINNAME: '최종수정자',
  GRID_UPDATEYMDT: '최종수정일시',
  GRID_SAFETYSTOCKSYNCY: '안전재고연동',
  GRID_SAFETYSTOCKSYNCN: '안전재고연동안함',
  GRID_CHANGEDATETIME: '변경일시',
  GRID_UPDATECNT: '변경재고',
  GRID_STOCKCNT: '최종재고<br>(판매가능재고)',
  GRID_SAFETYSTOCKCNT: '안전재고',
  GRID_CONTENTS: '내용',
  GRID_ADMINNAME: '담당자',
  SALE_STATUS_TYPE_ERROR: '판매상태를 체크해주세요.',
  SALE_SETTING_STATUS_TYPE_ERROR: '판매설정를 체크해주세요.',
  NO_DATA_ERROR: '데이터가 존재하지 않습니다.',
  ADJUSTABLE_RANGE: '조정가능 범위가 아닙니다.',
  EXCEL_BATCH_REGISTRATION: '엑셀 일괄등록',
  EXCELUPLOAD_DESCRIPTION1:
    '조회된 항목의 엑셀다운로드 후 변경 필요한 조정재고, 수정재고, 옵션관리코드, 추가관리코드 변경 후 업로드 해주시기 바랍니다.',
  EXCELUPLOAD_DESCRIPTION2:
    '엑셀다운로드 파일에서 항목 삭제 추가할 수 없습니다.',
  EXCELUPLOAD_DESCRIPTION3:
    '일괄 작성된 조정 및 수정된 재고 수량기준으로 업로드 완료 시 일괄 변경됩니다.',
  EXCELUPLOAD_DESCRIPTION4:
    '엑셀일괄등록 업로드 완료 하면 마스터 상품과 연동된 복사상품도 즉시 업로드 됩니다.',
  EXCELUPLOAD_DESCRIPTION5:
    '엑셀다운로드 파일에서 재고번호를 삭제하는 경우 조정 및 수정된 재고수량이 정상적으로 업로드 되지 않습니다.',
  EXCELUPLOAD_FIND_FILES: '파일찾기',
  POPUP_INPUT: '입력',
  SELECT_FILE: '엑셀파일을 등록해주세요.',
  EXCEL_NO_DATA: '엑셀 서식을 다시 확인해주세요.',
  EXCEL_DATA_ERROR: '엑셀 데이터를 정확히 입력해주세요.',
  LAST_SAVED: '최종 저장되었습니다.',
  EXCEL_NAME_ERROR: '등록 실패 했습니다. 확장자명을 다시 확인해주세요.',
  STOCK_MODIFY_TITLE_EDIT: '수정재고 일괄변경',
  STOCK_MODIFY_TITLE_ADJUST: '조정재고 일괄변경',
  STOCK_MODIFY_SELECTED: '선택하신',
  STOCK_MODIFY_CHECKCOUNT: '건 상품에 대해 조정재고 일괄 업데이트 됩니다.',
  STOCK_MODIFY_DESCRIPTION_ADJUST:
    '저장하시면 입력한 조정재고로 재고수량 일괄변경 되는 사항 유의하고 진행하시기 바랍니다.',
  STOCK_MODIFY_EDITCHECKCOUNT: '건 상품에 대해 수정재고 일괄 업데이트 됩니다.',
  STOCK_MODIFY_EDIT_DESCRIPTION1:
    '재고수량에서 수정재고 일괄 적용된 개수가 계산되어 조정재고 로 출력 됩니다.',
  STOCK_MODIFY_EDIT_DESCRIPTION2:
    '저장하시면 수정재고 가감한 개수로 재고수량 일괄 변경되는 사항 유의하시고 진행하시기 바랍니다.',
  STOCK_MODIFY_ADJUSTED_STOCK_COUNT: '조정재고 개수',
  STOCK_MODIFY_EDIT_STOCK_COUNT: '재고수정 개수',
  STOCK_MODIFY_CONFIRM:
    '선택하신 {0}건 상품옵션의 재고수량을 최종 저장 하시겠습니까?',
  MALLNO: '쇼핑몰번호',
  EXCELTITLE_HANDLERTYPE: '재고 변경 타입',
  EXCELTITLE_CURRENTSTOCK: '재고수량',
  CATEGORY_INFO_POP: '전시카테고리 추가정보',
  EXAMPLE: '보기',
  ERR_PRODUCT_NO_SELECT: '상품을 선택해주세요',
  POP_AGAIN_MSG: '팝업을 다시 열어주세요.',
  ADJUST_CNT_MSG: '조정가능범위가 아닙니다.',
  EDIT_CNT_MSG: '마이너스 수정 재고가 재고수량보다 큽니다.',
  BATCH_RESULT: '일괄적용 결과',
  BATCH_RESULT_TITLE1: '총 {0}개 상품 중',
  BATCH_RESULT_TITLE2: '상품에 대해 수정재고 변경 불가입니다.',
  MODIFY_STOCK_TYPE: '재고선택',
  MODIFY_STOCK_CNT: '재고수량 입력',
  UPLOAD_ERR: '{0}건 실패 되었습니다.',
  EDIT_STOCK_CNT_CONFIG_TOOLTIP_TIT: '수정재고 설정 안내',
  EDIT_STOCK_CNT_CONFIG_TOOLTIP_DESC1:
    '수정재고: 기존 재고수량에서  증·차감(+/-)이 필요한 재고 수량',
  EDIT_STOCK_CNT_CONFIG_TOOLTIP_DESC2:
    '재고 수정 중 상품 주문으로 재고 수량에 변동이 생기면, 상품재고관리 리스트에 표시된 재고 수량과 관계없이 변동된 수량에서 수정재고 항목에 입력된 값이 증/차감되어 변경됩니다.',
  EDIT_STOCK_CNT_CONFIG_TOOLTIP_DESC3:
    '상품 선택 후 수정재고와 조정재고를 모두 입력하지 않은 공란의 상태로 저장 시 기존 재고수량이 유지됩니다. ',
  ADJUST_STOCK_CNT_CONFIG_TOOLTIP_TIT: '조정재고 설정 안내',
  ADJUST_STOCK_CNT_CONFIG_TOOLTIP_DESC1:
    '조정재고 : 저장 이후 재고수량에 적용 할 재고로 최종 반영 전 조정된 재고 수량',
  ADJUST_STOCK_CNT_CONFIG_TOOLTIP_DESC2:
    '재고 수정 중 상품 주문으로 재고 수량이 변동되어도 입력된 조정재고 수량으로 변경됩니다.',
  ADJUST_STOCK_CNT_CONFIG_TOOLTIP_DESC3:
    '상품 선택 후 수정재고와 조정재고를 모두 입력하지 않은 공란의 상태로 저장 시 기존 재고수량이 유지됩니다. ',
})
